const API_ENDPOINT = 'WorkPlaces'

export const API_WORK_PLACES = {
  API_ENDPOINT,
  GET_ALL_DYNAMIC: `${API_ENDPOINT}/GetAllDynamic`,
  POST: `${API_ENDPOINT}/Create`,
  PATCH: (data: { id: WorkPlace['id'] }) =>  `${API_ENDPOINT}/Patch/${data.id}`,
  DELETE: (data: { id: WorkPlace['id'] }) => `${API_ENDPOINT}/Delete/${data.id}`,
}

export class WorkPlace {
  id!: string
  title: string = ''
  isActive: boolean = true
}
